import Vue from "vue";
import VueRouter from "vue-router";
import SchoolWebsite from "@/components/SchoolWebsite/SchoolWebsite.vue";
import ContactUs from "@/components/ContactPage/ContactUs.vue";

import EditAndPrintQuote from "@/components/InvoicesAndQuotes/EditAndPrintQuote.vue";

import TableDialog from "@/components/myLibrary/TableDialog.vue";
import ManageUsers from "@/modules/ManageUsers/ManageUsers.vue";
import DataAndReports from "@/components/GeneralComponents/DataAndReports.vue";

import FinanceSwitchboard from "@/components/BudgetAndFinances/FinanceSwitchboard.vue";
import FinanceDashboard from "@/components/BudgetAndFinances/FinanceDashboard.vue";
import PaymentReceiptComponent from "@/components/Incomes/PaymentReceiptComponent.vue";
import WebsiteDashboard from "@/components/SchoolWebsite/WebsiteDashboard.vue";
import WebsiteCrud from "@/components/SchoolWebsite/WebsiteCrud.vue";
import WebsiteImagesCrud from "@/components/SchoolWebsite/WebsiteImagesCrud.vue";

// import EventsCalendar from "@/components/EventsCalendar/EventsCalendar.vue";

import ClientProfile from "@/components/Clients/ClientProfile.vue";
import VideoTutorials from "@/components/Bitsems/VideoTutorials.vue";
import InvoicesAndQuotes from "@/components/InvoicesAndQuotes/InvoicesAndQuotes.vue";
import PayslipsPDF from "@/components/StaffAndHR/PayslipsPDF.vue";
import PayOnline from "@/components/OnlinePayment/PayOnline.vue";
import PaymentSuccessful from "@/components/OnlinePayment/PaymentSuccessful.vue";
import CancelPayment from "@/components/OnlinePayment/CancelPayment.vue";
import NotifyPayment from "@/components/OnlinePayment/NotifyPayment.vue";
import ManageCases from "@/components/Cases/ManageCases.vue";

import WebsiteManagePosts from "@/components/SchoolWebsite/WebsiteManagePosts.vue";
import WebsitePostRead from "@/components/SchoolWebsite/WebsitePostRead.vue";

import ManagePayroll from "@/components/StaffAndHR/ManagePayroll.vue";
import Expenses from "@/components/BudgetAndFinances/Expenses/Expenses.vue";
import Budgets from "@/components/BudgetAndFinances/Budgets/Budgets.vue";
import Accounts from "@/components/BudgetAndFinances/Accounts.vue";
import ManageStaff from "@/components/StaffAndHR/ManageStaff.vue";
import CreateCompany from "@/components/Company/CreateCompany.vue";
import AgencyTalents from "@/components/StaffAndHR/AgencyTalents.vue";
import SMSDashboard from "@/components/SMS/SMSDashboard.vue";
import AllProducts from "@/components/BitsCart/AllProducts.vue";
import Product from "@/components/BitsCart/Product.vue";
// import CartCheckout from "@/components/BitsCart/CartCheckout.vue";
import SwitchboardModule from "@/modules/Switchboard/routes.js";
import ManageUsersModule from "@/modules/ManageUsers/routes.js";
import ManageProducts from "@/modules/ProductsAndServices/routes.js";
import POSModule from "@/modules/POS/routes.js";
import SettingsModule from "@/modules/Settings/routes.js";
import CrudDatabasesModule from "@/modules/CrudDatabases/routes.js";
import EmailsModule from "@/modules/Emails/routes.js";
import AuthModule from "@/modules/Auth/routes.js";
import OnboardNewClientsModule from "@/modules/OnboardNewClients/routes.js";
import ActivityTrackerModule from "@/modules/ActivityTracker/routes.js";

Vue.use(VueRouter);

const routes = [
  ...AuthModule,
  ...SwitchboardModule,
  ...ManageUsersModule,
  ...ManageProducts,
  ...POSModule,
  ...SettingsModule,
  ...CrudDatabasesModule,
  ...EmailsModule,
  ...OnboardNewClientsModule,
  ...ActivityTrackerModule,
  {
    path: "/",
    name: "company-website",
    component: SchoolWebsite,
  },
  {
    path: "/home",
    name: "home",
    component: SchoolWebsite,
  },
  {
    path: "/free-invoices-and-quotes",
    name: "free-invoices-and-quotes",
    component: () =>
      import("@/components/InvoicesAndQuotes/CreateInvoiceFrontPage.vue"),
  },
  {
    path: "/create-company",
    name: "create-company",
    component: CreateCompany,
  },
  {
    path: "/manage-talents",
    name: "manage-talents",
    component: AgencyTalents,
  },

  {
    path: "/data-and-reports",
    name: "data-and-reports",
    component: DataAndReports,
  },
  {
    path: "/video-tutorials",
    name: "video-tutorials",
    component: VideoTutorials,
  },
  {
    path: "/manage-clients",
    name: "manage-clients",
    component: ClientProfile,
  },
  {
    path: "/pay-online",
    name: "pay-online",
    component: PayOnline,
  },
  {
    path: "/payment-successful",
    name: "payment-successful",
    component: PaymentSuccessful,
  },
  {
    path: "/notify-payment",
    name: "notify-payment",
    component: NotifyPayment,
  },
  {
    path: "/cancel-payment",
    name: "cancel-payment",
    component: CancelPayment,
  },
  {
    path: "/finance-switchboard",
    name: "finance-switchboard",
    component: FinanceSwitchboard,
  },
  {
    path: "/finance-dashboard",
    name: "finance-dashboard",
    component: FinanceDashboard,
  },

  {
    path: "/financial-accounts",
    name: "financial-accounts",
    component: Accounts,
  },
  {
    path: "/finance-expenses",
    name: "finance-expenses",
    component: Expenses,
  },
  {
    path: "/financial-budgets",
    name: "financial-budgets",
    component: Budgets,
  },
  {
    path: "/website-dashboard",
    name: "website-dashboard",
    component: WebsiteDashboard,
  },
  {
    path: "/manage-images",
    name: "manage-images",
    component: WebsiteImagesCrud,
  },
  {
    path: "/website-manage-posts",
    name: "website-manage-posts",
    component: WebsiteManagePosts,
  },
  {
    path: "/read-post",
    name: "read-post",
    component: WebsitePostRead,
    props: true,
  },
  {
    path: "/website-manage-profile",
    name: "website-manage-profile",
    component: WebsiteImagesCrud,
  },
  {
    path: "/invoices-and-quotes",
    name: "invoices-and-quotes",
    component: InvoicesAndQuotes,
  },
  {
    path: "/edit-and-print-quote",
    name: "edit-and-print-quote",
    component: EditAndPrintQuote,
  },
  {
    path: "/get-payslips-pdf",
    name: "get-payslips-pdf",
    component: PayslipsPDF,
  },
  {
    path: "/manage-employees",
    name: "manage-employees",
    component: ManageStaff,
  },
  {
    path: "/salaries-and-payslips",
    name: "salaries-and-payslips",
    component: ManagePayroll,
  },
  {
    path: "/manage-files",
    name: "manage-files",
    component: ManageCases,
  },
  {
    path: "/bulk-sms-dashboard",
    name: "bulk-sms-dashboard",
    component: SMSDashboard,
  },
  // {
  //   path: "/events-calendar",
  //   name: "events-calendar",
  //   component: EventsCalendar,
  // },

  {
    path: "/crud-website-data",
    name: "crud-website-data",
    component: WebsiteCrud,
  },
  {
    path: "/payments-receipt",
    name: "payments-receipt",
    component: PaymentReceiptComponent,
  },
  {
    path: "/manage-users",
    name: "manage-users",
    component: ManageUsers,
  },
  // {
  //   path: "/crud-admin",
  //   name: "crud-admin",
  //   component: CrudAdmin,
  // },
  // {
  //   path: "/admin-manage-database",
  //   name: "admin-manage-database",
  //   component: AdminManageDatabase,
  // },

  {
    path: "/related-table",
    name: "related-table",
    component: TableDialog,
  },
  {
    path: "/contact-us",
    name: "contact-us",
    component: ContactUs,
  },
  // {
  //   path: "/donation",
  //   name: "donation",
  //   component: Donation,
  // },

  {
    path: "/web-store",
    name: "web-store",
    component: AllProducts,
  },
  {
    path: "/product-details",
    name: "product-details",
    component: Product,
  },
  // {
  //   path: "/checkout",
  //   name: "checkout",
  //   component: CartCheckout,
  // },
  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (
    localStorage.getItem("authenticated") != null &&
    localStorage.getItem("token") != null
  ) {
    next();
  } else {
    if (
      to.path == "/" ||
      to.path == "/home" ||
      to.path == "/login" ||
      to.path == "/company-website" ||
      to.path == "/free-invoices-and-quotes" ||
      to.path == "/register" ||
      to.path == "/bitsems-register" ||
      to.path == "/web-store" ||
      to.path == "/product-details" ||
      to.path == "/checkout" ||
      to.path == "/images-gallery" ||
      to.path == "/onboarding-new-company" ||
      to.path == "/payment-complete" ||
      to.path == "/cancel-onboarding" ||
      to.path == "/report-builder" ||
      to.path == "/contact-us"
    ) {
      next();
    } else {
      next("/");
    }
  }
});

export default router;
